export default __webpack_public_path__ + "static/media/09.d3d78e55.jpg";